import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslocoModule} from '@jsverse/transloco';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core/core.module';

import {LoginComponent} from './login/login.component';
import {AuthenticationComponent} from './authentication.component';
import {RegisterComponent} from './register/register.component';
import {AuthenticationRestApiService} from './services/http/authentication-rest-api.service';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ExpiredPasswordComponent} from './expired-password/expired-password.component';
import {TwoFactorCheckComponent} from './two-factor-check/two-factor-check.component';

@NgModule({
  declarations: [
    AuthenticationComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ExpiredPasswordComponent,
    TwoFactorCheckComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    RouterModule,

    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,

    SharedModule,
    CoreModule,
  ],
  providers: [
    AuthenticationRestApiService,
  ],
})
export class AuthenticationModule {
}
